import { render, staticRenderFns } from "./classroomCardsManagement.vue?vue&type=template&id=877b318e&"
import script from "./classroomCardsManagement.vue?vue&type=script&lang=js&"
export * from "./classroomCardsManagement.vue?vue&type=script&lang=js&"
import style0 from "./classroomCardsManagement.vue?vue&type=style&index=0&id=877b318e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports